/**
 * Page context hook — any page can call setPageContext({...}) to tell the
 * Brain popout chat where the user is and what they're looking at.
 *
 * The popout chat reads window.__heistPageContext__ when opening and
 * injects a system-prompt preamble so the Brain can anticipate relevant
 * actions (fill calendar, generate variations, swap autopilot topic, etc.).
 *
 * Phase 3 foundation. Popout UI polish + per-page quick actions come in
 * future commits once we validate the pattern.
 */
export function setPageContext(ctx) {
    try { window.__heistPageContext__ = ctx || null; } catch (_) {}
}
export function getPageContext() {
    try { return window.__heistPageContext__ || null; } catch (_) { return null; }
}
export function clearPageContext() {
    try { window.__heistPageContext__ = null; } catch (_) {}
}
